import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PasslySelect } from '@app/components';
import { IUserData } from '@app/models';
import { Administrator } from '@app/store/constants';
import { changeBullPhishOrganizationSelect } from '@app/store/actions';
import { defaultOrgId } from '@app/helpers';
import { useTypedTranslation } from '@app/hooks';

export const BullPhishOrganizationsSelect: React.SFC = () => {
    const { translation } = useTypedTranslation();

    const orgPermissions: IUserData['orgPermissions'] = useSelector((state: any) => state.signIn.currentUser.orgPermissions);
    const selectData = useSelector((state: any) => state.basic.shellConfig.organizations);
    const [selectDataFiltered, setSelectDataFiltered] = React.useState([]);
    const [selected, setSelected] = React.useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectData.length) {
            let defaultOrgPermissions: any = orgPermissions[defaultOrgId];
            const isNeedToFilter = !(defaultOrgPermissions?.length && defaultOrgPermissions.indexOf(Administrator) >= 0);

            const selectDataFiltered = isNeedToFilter
                ? selectData.filter((data: any) => {
                      let haveOrgAdminPermission = false;

                      Object.keys(orgPermissions).forEach((org) => {
                          if (org === data.id && orgPermissions[data.id].indexOf(Administrator) >= 0) {
                              haveOrgAdminPermission = true;
                          }
                      });

                      return haveOrgAdminPermission;
                  })
                : selectData;

            setSelectDataFiltered(selectDataFiltered);

            if (!selected) {
                setSelected(selectDataFiltered[0].id);
                dispatch(changeBullPhishOrganizationSelect(selectDataFiltered[0].id));
            }
        }
    }, [selectData]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value !== selected) {
            setSelected(event.target.value);
            dispatch(changeBullPhishOrganizationSelect(event.target.value));
        }
    };

    return (
        <>
            {selectDataFiltered?.length > 1 && (
                <PasslySelect
                    id='bullPhishOrgSelector'
                    className='bullPhishOrgSelector'
                    label={translation('ORGANIZATION_SELECTION')}
                    value={selected}
                    onChange={handleChange}
                    options={selectDataFiltered}
                    optionLabel='name'
                    optionValue='id'
                />
            )}
        </>
    );
};
